"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _UCZW3OGHcjs = require('./UCZW3OGH.cjs');


var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');



var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/composite/composite-row.tsx
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
var useCompositeRow = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useCompositeRow2({
    store,
    "aria-setsize": ariaSetSize,
    "aria-posinset": ariaPosInSet,
    ...props
  }) {
    const context = _UCZW3OGHcjs.useCompositeContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "CompositeRow must be wrapped in a Composite component."
    );
    const id = _3BSDKDKDcjs.useId.call(void 0, props.id);
    const baseElement = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      store,
      (state) => state.baseElement || void 0
    );
    const providerValue = _react.useMemo.call(void 0, 
      () => ({ id, baseElement, ariaSetSize, ariaPosInSet }),
      [id, baseElement, ariaSetSize, ariaPosInSet]
    );
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _UCZW3OGHcjs.CompositeRowContext.Provider, { value: providerValue, children: element }),
      [providerValue]
    );
    props = { ...props, id };
    return _misc.removeUndefinedValues.call(void 0, props);
  }
);
var CompositeRow = _PTOCUU2Dcjs.forwardRef.call(void 0, function CompositeRow2(props) {
  const htmlProps = useCompositeRow(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useCompositeRow = useCompositeRow; exports.CompositeRow = CompositeRow;
